import React, { useState, useContext } from "react";
import {
  Nav,
  Navbar,
  Container,
  Button,
  Modal,
  ProgressBar,
} from "react-bootstrap";

import { Utils, UserContext } from "./../../common";
import _ from "lodash";

const hasAnyPath = (pathary) => {
  return (
    _.filter(pathary, (path) => window.location.pathname.indexOf(path) > -1)
      .length > 0
  );
};

const activeClass = (bool) => {
  return bool ? "py-2 active" : "py-2";
};

const varmenu = {
  dashboard: ["dashboard"],
  timehub: ["attendance", "myrota", "leave"],
  workflow: ["jobs", "todo"],
  training: ["cpd", "resources", "help-materials"],
  performance: ["reports", "evidences"],
  adminc: ["comrota", "users", "cqc", "userdocument", "myprofile"],
};

const pageLoadedMenu = () => {
  var val = "";
  _.each(varmenu, (ary, key) => {
    if (hasAnyPath(ary)) val = key;
  });
  return val;
};

const imageState = (nm) => {
  var src = process.env.PUBLIC_URL + "/images/" + nm;

  if (!hasAnyPath(varmenu[nm])) {
    src += "-d";
  }
  src += ".png";
  return (
    <img
      src={src}
      style={{ marginRight: "18px !important", marginLeft: "10px" }}
      width="19"
      alt={nm}
    />
  );
};

const Header = (props) => {
  const [showLogout, setShowLogout] = useState(false);

  const { userData, goTraining, showPlan, setShowPlan } =
    useContext(UserContext);
  const [training, setTraining] = useState(false);
  const [openMenu, setOpenMenu] = useState(pageLoadedMenu());

  if (!Utils.isLoggedIn()) {
    window.location.href = process.env.PUBLIC_URL + "/login";
  }

  const handleGoTraining = (e) => {
    setTraining(true);
    goTraining()
      .then(() => setTraining(false))
      .catch(() => setTraining(false));
  };

  const isActive = (path) => {
    if (window.location.pathname.indexOf(path) > -1) {
      return "active";
    } else {
      return "";
    }
  };

  const getLogo = () => {
    const uData = Utils.getUserData();
    let logo = _.get(uData, "logo", "");
    if (logo === "") {
      return process.env.PUBLIC_URL + "/images/logo.png";
    } else {
      return Utils.apiUrl("../uploads/logos/" + logo);
    }
  };

  const count = (p) => {
    return parseInt(_.get(Utils.getUserData(), p, 0));
  };

  const remainingThings = () => {
    const j = count("jobs");
    const t = count("tasks");
    let tmp = [];
    if (j > 0) {
      tmp.push(`${j} job${j > 1 ? "s" : ""}`);
    }
    if (t > 0) {
      tmp.push(`${t} To Do`);
    }

    if (tmp.length > 0) {
      return (
        <h5 className="text-blue">
          <b>You have {tmp.join(" and ")} pending.</b>
        </h5>
      );
    } else {
      return <></>;
    }
  };

  const logMeOut = () => {
    window.location.href = `${process.env.PUBLIC_URL}/logout`;
  };

  const confirmLogout = () => {
    return (
      <Modal show={showLogout} centered>
        <Modal.Header style={{ borderBottom: "0" }} className="pb-0 mb-0">
          <img
            src={`${process.env.PUBLIC_URL}/images/close.png`}
            className="ms-auto clickable"
            title="Close"
            alt="Close"
            onClick={() => setShowLogout(false)}
          />
        </Modal.Header>
        <Modal.Body className="bg-white text-center px-5">
          <img
            src={`${process.env.PUBLIC_URL}/images/alert.png`}
            className="mb-3"
            alt="Information"
          />
          {remainingThings()}
          <h4 className="text-danger mt-3">
            <b>Are you sure you want to logout?</b>
          </h4>
          <Button
            variant="primary"
            className="d-block mx-auto mt-4 w-100"
            onClick={() => setShowLogout(false)}
          >
            No
            {(count("jobs") > 0 || count("tasks")) > 0 && (
              <>. I will complete the job</>
            )}
          </Button>
          <Button
            variant="outline-danger"
            className="d-block mx-auto mt-2 mb-4 w-100"
            onClick={logMeOut}
          >
            Yes
          </Button>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <div>
      <Navbar bg="white" expand="sm" fixed="top">
        <Container fluid>
          <Navbar.Toggle aria-controls="offcanvasNavbar" className="m-0 p-0" />
          <Navbar.Brand href="#home" className="orglogo">
            <div className="d-none d-sm-flex" style={{ width: "225px" }}>
              <img
                src={getLogo()}
                style={{ maxHeight: "70px", maxWidth: "calc(100% - 20px)" }}
                className="d-inline-block logo"
                alt={process.env.REACT_APP_APPNAME}
              />
              <div className="m-auto">
                <img
                  className="float-end"
                  src={`${process.env.PUBLIC_URL}/images/sidebar-${props.sidebar ? "close" : "open"}.png`}
                  onClick={props.showSidebar}
                />
              </div>
            </div>
            <div className="d-block d-sm-none">
              <img
                src={getLogo()}
                style={{ maxHeight: "70px" }}
                className="d-inline-block logo"
                alt={process.env.REACT_APP_APPNAME}
              />
            </div>
          </Navbar.Brand>
          {userData.name && (
            <div className="mobname">
              {userData.is_super_user &&
                _.get(userData, "plan_expires", false) !== false && (
                  <>
                    <img
                      src={`${process.env.PUBLIC_URL}/images/view-subscription.png`}
                      className="m-2 clickable"
                      onClick={() => setShowPlan(!showPlan)}
                    />
                  </>
                )}
              <img
                src={`${process.env.PUBLIC_URL}/images/notification.png`}
                className="notifyctrl m-2 clickable"
                onClick={() => props.setShowNoti(!props.showNoti)}
              />
              {userData.name.split(" ")[1]}
            </div>
          )}
          {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}
          <Navbar.Collapse
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
            placement="end"
          >
            <Nav className="justify-content-end flex-grow-1 pe-3 d-block d-sm-none m-0 p-2 sidemenu">
              <div className="btn-primary text-white p-4 mb-3">
                <b>{userData.name}</b>
                <br />
                <button
                  className="btn btn-sm btn-danger mt-3 p-0 px-2"
                  onClick={() => setShowLogout(true)}
                >
                  Logout
                </button>
              </div>
              {(userData.is_super_user || Utils.hasAccess(1)) && (
                <Nav.Link
                  className={isActive("dashboard")}
                  href={`${process.env.PUBLIC_URL}/dashboard`}
                >
                  {imageState("dashboard")} Dashboard
                </Nav.Link>
              )}

              {(userData.is_super_user ||
                Utils.hasAccess(2) ||
                Utils.hasAccess(5)) && (
                <>
                  <div
                    className={`nav-link ${isActive(["attendance", "myrota", "leave"])} ${activeClass(openMenu === "timehub")}`}
                  >
                    <div
                      onClick={() =>
                        setOpenMenu(openMenu === "timehub" ? "" : "timehub")
                      }
                    >
                      {imageState("timehub")} Time Hub{" "}
                      <img
                        className="mt-2 float-end"
                        src={`${process.env.PUBLIC_URL}/images/menu-${openMenu === "timehub" ? "opened" : "closed"}.png`}
                      />
                    </div>

                    <div
                      className={`submenu ${openMenu === "timehub" ? "d-block" : "d-none"}`}
                    >
                      {(userData.is_super_user || Utils.hasAccess(2)) && (
                        <a
                          className={isActive(["attendance"])}
                          href={`${process.env.PUBLIC_URL}/attendance`}
                        >
                          Attendance
                        </a>
                      )}
                      {(userData.is_super_user || Utils.hasAccess(2)) && (
                        <a
                          className={isActive(["myrota"])}
                          href={`${process.env.PUBLIC_URL}/myrota`}
                        >
                          My Rota
                        </a>
                      )}
                      {(userData.is_super_user || Utils.hasAccess(5)) && (
                        <a
                          className={isActive(["leave"])}
                          href={`${process.env.PUBLIC_URL}/leave`}
                        >
                          Holiday
                        </a>
                      )}
                    </div>
                  </div>
                </>
              )}

              {(userData.is_super_user ||
                Utils.hasAccess(3) ||
                Utils.hasAccess(4)) && (
                <>
                  <div
                    className={`nav-link ${isActive(["jobs", "todo"])} ${activeClass(openMenu === "workflow")}`}
                  >
                    <div
                      onClick={() =>
                        setOpenMenu(openMenu === "workflow" ? "" : "workflow")
                      }
                    >
                      {imageState("workflow")} Workflow{" "}
                      <img
                        className="mt-2 float-end"
                        src={`${process.env.PUBLIC_URL}/images/menu-${openMenu === "workflow" ? "opened" : "closed"}.png`}
                      />
                    </div>

                    <div
                      className={`submenu ${openMenu === "workflow" ? "d-block" : "d-none"}`}
                    >
                      {(userData.is_super_user || Utils.hasAccess(3)) && (
                        <a
                          className={isActive(["jobs"])}
                          href={`${process.env.PUBLIC_URL}/jobs`}
                        >
                          Jobs
                        </a>
                      )}
                      {(userData.is_super_user || Utils.hasAccess(4)) && (
                        <a
                          className={isActive(["todo"])}
                          href={`${process.env.PUBLIC_URL}/todo`}
                        >
                          Tasks
                        </a>
                      )}
                    </div>
                  </div>
                </>
              )}

              {(userData.is_super_user ||
                Utils.hasAccess(6) ||
                Utils.hasAccess(8) ||
                Utils.hasAccess(9)) && (
                <>
                  <div
                    className={`nav-link ${isActive(["resources", "help-materials"])} ${activeClass(openMenu === "training")}`}
                  >
                    <div
                      onClick={() =>
                        setOpenMenu(openMenu === "training" ? "" : "training")
                      }
                    >
                      {imageState("training")} Training{" "}
                      <img
                        className="mt-2 float-end"
                        src={`${process.env.PUBLIC_URL}/images/menu-${openMenu === "training" ? "opened" : "closed"}.png`}
                      />
                    </div>

                    <div
                      className={`submenu ${openMenu === "training" ? "d-block" : "d-none"}`}
                    >
                      {!training &&
                        (userData.is_super_user || Utils.hasAccess(9)) && (
                          <Nav.Link onClick={handleGoTraining}>CPD</Nav.Link>
                        )}
                      {(userData.is_super_user || Utils.hasAccess(6)) && (
                        <a
                          className={isActive(["resources"])}
                          href={`${process.env.PUBLIC_URL}/resources`}
                        >
                          Resources
                        </a>
                      )}
                      {(userData.is_super_user || Utils.hasAccess(8)) && (
                        <a
                          className={isActive(["help-materials"])}
                          href={`${process.env.PUBLIC_URL}/help-materials`}
                        >
                          Help Materials
                        </a>
                      )}
                    </div>
                  </div>
                </>
              )}

              {(userData.is_super_user ||
                Utils.hasAccess(7) ||
                userData.manager) && (
                <>
                  <div
                    className={`nav-link ${isActive(["reports", "evidences"])} ${activeClass(openMenu === "performance")}`}
                  >
                    <div
                      onClick={() =>
                        setOpenMenu(
                          openMenu === "performance" ? "" : "performance",
                        )
                      }
                    >
                      {imageState("performance")} Performance{" "}
                      <img
                        className="mt-2 float-end"
                        src={`${process.env.PUBLIC_URL}/images/menu-${openMenu === "performance" ? "opened" : "closed"}.png`}
                      />
                    </div>

                    <div
                      className={`submenu ${openMenu === "performance" ? "d-block" : "d-none"}`}
                    >
                      {userData.manager && (
                        <a
                          className={isActive(["reports"])}
                          href={`${process.env.PUBLIC_URL}/reports`}
                        >
                          Reports
                        </a>
                      )}
                      {(userData.is_super_user || Utils.hasAccess(7)) && (
                        <a
                          className={isActive(["evidences"])}
                          href={`${process.env.PUBLIC_URL}/evidences`}
                        >
                          Evidence
                        </a>
                      )}
                    </div>
                  </div>
                </>
              )}

              {(Utils.hasAccess(10) ||
                userData.is_super_user ||
                userData.is_rota ||
                userData.is_cqc) && (
                <>
                  <div
                    className={`nav-link ${isActive(["users", "comrota", "myprofile", "cqc"])} ${activeClass(openMenu === "adminc")}`}
                  >
                    <div
                      onClick={() =>
                        setOpenMenu(openMenu === "adminc" ? "" : "adminc")
                      }
                    >
                      {imageState("adminc")} Compliance{" "}
                      <img
                        className="mt-2 float-end"
                        src={`${process.env.PUBLIC_URL}/images/menu-${openMenu === "adminc" ? "opened" : "closed"}.png`}
                      />
                    </div>

                    <div
                      className={`submenu ${openMenu === "adminc" ? "d-block" : "d-none"}`}
                    >
                      {userData.is_rota && (
                        <a
                          className={isActive(["comrota"])}
                          href={`${process.env.PUBLIC_URL}/comrota`}
                        >
                          Rota
                        </a>
                      )}
                      {userData.is_super_user && (
                        <a
                          className={isActive(["users"])}
                          href={`${process.env.PUBLIC_URL}/users`}
                        >
                          Users
                        </a>
                      )}
                      {userData.is_cqc && (
                        <a
                          className={isActive(["cqc"])}
                          href={`${process.env.PUBLIC_URL}/cqc`}
                        >
                          CQC
                        </a>
                      )}
                      {userData.is_super_user && (
                        <a
                          className={isActive(["userdocument"])}
                          href={`${process.env.PUBLIC_URL}/userdocument`}
                        >
                          HR
                        </a>
                      )}
                      {(userData.is_super_user || Utils.hasAccess(10)) && (
                        <a
                          className={isActive(["myprofile"])}
                          href={`${process.env.PUBLIC_URL}/myprofile`}
                        >
                          My Profile
                        </a>
                      )}
                    </div>
                  </div>
                </>
              )}

              {training && (userData.is_super_user || Utils.hasAccess(9)) && (
                <ProgressBar
                  variant="info"
                  animated
                  now={100}
                  className="mx-5"
                />
              )}
              <div className="d-block text-center poweredBy mt-5 mb-3">
                <img
                  src={`${process.env.PUBLIC_URL}/images/poweredBy.png`}
                  width="124"
                  height="42"
                  className=""
                  alt={process.env.REACT_APP_POWEREDBY}
                />{" "}
              </div>
            </Nav>
          </Navbar.Collapse>
          {Utils.isLoggedIn() && (
            <Navbar.Text className="d-none d-sm-inline">
              <Navbar.Text className="d-flex text-end">
                {userData.is_super_user &&
                  _.get(userData, "plan_expires", false) !== false && (
                    <>
                      <img
                        src={`${process.env.PUBLIC_URL}/images/view-subscription.png`}
                        className="m-2 clickable"
                        onClick={() => setShowPlan(!showPlan)}
                      />
                      <Nav.Link className="px-0 me-2">
                        <span
                          className="btn p-0"
                          onClick={() => setShowPlan(!showPlan)}
                        >
                          {!showPlan && <>View</>}
                          {showPlan && <>Hide</>}
                          <span className="ps-1">Subscription</span>
                        </span>
                      </Nav.Link>
                    </>
                  )}
                <img
                  src={`${process.env.PUBLIC_URL}/images/notification.png`}
                  className="notifyctrl m-2 clickable"
                  onClick={() => props.setShowNoti(!props.showNoti)}
                />
                <span className="my-auto me-2">{userData.name}</span>
                <Nav.Link className="px-0">
                  <button
                    className="btn btn-sm btn-danger p-0 px-2"
                    onClick={() => setShowLogout(true)}
                  >
                    Logout
                  </button>
                </Nav.Link>
              </Navbar.Text>
            </Navbar.Text>
          )}
        </Container>
      </Navbar>
      {confirmLogout()}
    </div>
  );
};

export default Header;
